import { gql } from 'apollo-boost';

export const clientDevQuery = gql`
    query ClientDevQuery {
        clientDev {
            clientId
            environment
            operatorLogin
            role
            shard
            uid
            operatorFeatures
            clientFeatures
        }
        reqId: getReqId
    }
`;
